import { createIcon } from '../createIcon.tsx';

export const ChevronRightIcon = createIcon('ChevronRightIcon', <polyline points="9 18 15 12 9 6" />);
